import type { ClientCompanyViewDto } from '@/types/company'

interface CompanyViewDetailsProps {
  company: ClientCompanyViewDto
}

export function CompanyViewDetails({ company }: CompanyViewDetailsProps) {
  return (
    <div>
      <div className="grid grid-cols-1 gap-6 mb-6">
        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">Company Type</label>
              <div className="text-slate-900 dark:text-slate-100">{company.CompanyType}</div>
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">Industry</label>
              <div className="text-slate-900 dark:text-slate-100">{company.Industry}</div>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">Size</label>
              <div className="text-slate-900 dark:text-slate-100">{company.Size}</div>
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">Status</label>
              <div className="text-slate-900 dark:text-slate-100">{company.Status}</div>
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">Company URL</label>
            <div className="text-slate-900 dark:text-slate-100 break-all">{company.CompanyUrl}</div>
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">LinkedIn URL</label>
            <div className="text-slate-900 dark:text-slate-100 break-all">{company.LinkedInUrl || 'Not provided'}</div>
          </div>

        </div>
      </div>
    </div>
  )
}
